import { useState } from "react";
import GameShell from "../GameShell";

/**
 * Biblioteca Secreta — TDE-II inspired.
 * 8 challenges: 4 reading (correct spelling) + 4 arithmetic.
 */
export default function SecretLibrary() {
  return (
    <GameShell gameId="secret_library" title="Biblioteca Secreta">
      {({ onFinish }) => <Game onFinish={onFinish} />}
    </GameShell>
  );
}

const READING = [
  { q: "Qual está escrito CORRETAMENTE?", options: ["caza", "casa", "kaza", "cassa"], answer: "casa" },
  { q: "Qual está escrito CORRETAMENTE?", options: ["xícara", "chicara", "shicara", "tícara"], answer: "xícara" },
  { q: "Qual está escrito CORRETAMENTE?", options: ["pessoa", "peçoa", "pesoa", "pessoua"], answer: "pessoa" },
  { q: "Qual está escrito CORRETAMENTE?", options: ["assucar", "açúcar", "açukar", "asúcar"], answer: "açúcar" },
];

const MATH = [
  { q: "5 + 3 = ?", options: ["6", "7", "8", "9"], answer: "8" },
  { q: "12 − 4 = ?", options: ["6", "7", "8", "9"], answer: "8" },
  { q: "3 × 4 = ?", options: ["7", "10", "12", "14"], answer: "12" },
  { q: "20 ÷ 5 = ?", options: ["3", "4", "5", "6"], answer: "4" },
];

const ALL = [
  ...READING.map((q) => ({ ...q, type: "reading", icon: "📜" })),
  ...MATH.map((q) => ({ ...q, type: "math", icon: "🔢" })),
];

function Game({ onFinish }) {
  const [idx, setIdx] = useState(0);
  const [hits, setHits] = useState({ reading: 0, math: 0 });
  const [misses, setMisses] = useState({ reading: 0, math: 0 });
  const [rts, setRts] = useState([]);
  const [tStart, setTStart] = useState(() => performance.now());
  const [started] = useState(() => performance.now());
  const [feedback, setFeedback] = useState(null);

  const q = ALL[idx];
  const choose = (opt) => {
    if (feedback) return;
    const rt = performance.now() - tStart;
    const correct = opt === q.answer;
    setRts((r) => [...r, rt]);
    if (correct) setHits((h) => ({ ...h, [q.type]: h[q.type] + 1 }));
    else setMisses((m) => ({ ...m, [q.type]: m[q.type] + 1 }));
    setFeedback(correct ? "✅" : "❌");
    setTimeout(() => {
      const next = idx + 1;
      if (next >= ALL.length) {
        const elapsed = performance.now() - started;
        const totalReadingHits = hits.reading + (q.type === "reading" && correct ? 1 : 0);
        const totalReadingMisses = misses.reading + (q.type === "reading" && !correct ? 1 : 0);
        const totalMathHits = hits.math + (q.type === "math" && correct ? 1 : 0);
        const totalMathMisses = misses.math + (q.type === "math" && !correct ? 1 : 0);
        const totalHits = totalReadingHits + totalMathHits;
        const totalMisses = totalReadingMisses + totalMathMisses;
        const avg = [...rts, rt].reduce((a, b) => a + b, 0) / (rts.length + 1);
        onFinish({
          score: Math.max(0, Math.round(totalHits * 12 - totalMisses * 4)),
          duration_ms: Math.round(elapsed),
          metrics: {
            hits: totalHits,
            misses: totalMisses,
            reading_hits: totalReadingHits,
            reading_total: READING.length,
            math_hits: totalMathHits,
            math_total: MATH.length,
            avg_reaction_ms: Math.round(avg),
            accuracy: Number((totalHits / ALL.length).toFixed(3)),
          },
        });
      } else {
        setFeedback(null);
        setIdx(next);
        setTStart(performance.now());
      }
    }, 450);
  };

  return (
    <div className="mt-4 max-w-2xl mx-auto" data-testid="library-area">
      <div className="text-center text-white drop-shadow mb-4">
        <div className="text-sm">Desvende os feitiços antigos!</div>
        <div className="text-xs mt-1 opacity-80">Desafio {idx + 1} / {ALL.length}</div>
      </div>
      <div className="kid-card pop-in" key={idx}>
        <div className="flex items-center justify-center gap-3 mb-4 text-3xl">
          <span>{q.icon}</span>
          <span className="text-slate-800 font-bold">{q.q}</span>
        </div>
        <div className="grid grid-cols-2 gap-3">
          {q.options.map((opt, i) => (
            <button
              key={i}
              onClick={() => choose(opt)}
              className="bg-sky-50 hover:bg-sky-100 active:scale-95 transition rounded-2xl px-4 py-4 text-2xl font-bold text-slate-800 border-2 border-transparent hover:border-sky-300"
              data-testid={`library-opt-${i}`}
            >
              {opt}
            </button>
          ))}
        </div>
        {feedback && (
          <div className="text-center text-4xl mt-3 pop-in" data-testid="library-feedback">
            {feedback}
          </div>
        )}
      </div>
    </div>
  );
}
